var upvProductLifecycle = window.UpvanityProductLifecycle || {};
upvProductLifecycle.sliderChangeHandlers = upvProductLifecycle.sliderChangeHandlers || new WeakMap();
upvProductLifecycle.sliderResizeTimers = upvProductLifecycle.sliderResizeTimers || new WeakMap();
upvProductLifecycle.productMediaSelectHandlers = upvProductLifecycle.productMediaSelectHandlers || new WeakMap();
upvProductLifecycle.productMediaGalleryStates = upvProductLifecycle.productMediaGalleryStates || new WeakMap();
upvProductLifecycle.productMediaSyncTasks = upvProductLifecycle.productMediaSyncTasks || new WeakMap();
upvProductLifecycle.zoomHandlers = upvProductLifecycle.zoomHandlers || new WeakMap();
upvProductLifecycle.sizeChartHandlers = upvProductLifecycle.sizeChartHandlers || new WeakMap();
upvProductLifecycle.productModelRecords = upvProductLifecycle.productModelRecords || new WeakMap();
upvProductLifecycle.processedProductModelJson = upvProductLifecycle.processedProductModelJson || new WeakSet();
upvProductLifecycle.productModelFeaturesRequested = upvProductLifecycle.productModelFeaturesRequested === true;
upvProductLifecycle.shopifyXRReadyHandler = upvProductLifecycle.shopifyXRReadyHandler || null;
upvProductLifecycle.scrollFrame = upvProductLifecycle.scrollFrame || null;
upvProductLifecycle.thumbnailState = upvProductLifecycle.thumbnailState || null;
window.UpvanityProductLifecycle = upvProductLifecycle;

function getProductElement(section, selector) {
  var root = section || document;
  if (root.matches && root.matches(selector)) {
    return root;
  }
  return root.querySelector ? root.querySelector(selector) : null;
}

function getProductFlickity(element) {
  if (!element || typeof Flickity === 'undefined' || typeof Flickity.data !== 'function') {
    return null;
  }
  return Flickity.data(element) || null;
}

function getLegacyProductSlider(kind) {
  if (kind === 'thumb') {
    return typeof productThumbSlider !== 'undefined' ? productThumbSlider : window.productThumbSlider;
  }
  return typeof productSlider !== 'undefined' ? productSlider : window.productSlider;
}

function setLegacyProductSlider(kind, instance) {
  if (kind === 'thumb') {
    productThumbSlider = instance;
    window.productThumbSlider = instance;
  } else {
    productSlider = instance;
    window.productSlider = instance;
  }
}

function shouldEnableProductSlider(element) {
  var isMobile = window.matchMedia
    ? window.matchMedia('(max-width: 767px)').matches
    : window.innerWidth < 768;
  if (element.hasAttribute('data-mobile-only')) {
    return isMobile;
  }
  if (element.hasAttribute('data-desktop-only')) {
    return !isMobile;
  }
  return true;
}

function pauseProductMedia(element) {
  if (!element) return;
  element.querySelectorAll('.yv-youtube-video').forEach(function(video) {
    if (video.contentWindow) {
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  });
  element.querySelectorAll('.yv-vimeo-video').forEach(function(video) {
    if (video.contentWindow) {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    }
  });
  element.querySelectorAll('video').forEach(function(video) {
    if (typeof video.pause === 'function') video.pause();
  });
  element.querySelectorAll('.yv-product-model-item').forEach(function(model) {
    var record = upvProductLifecycle.productModelRecords.get(model);
    if (record && record.modelViewerUI && typeof record.modelViewerUI.pause === 'function') {
      record.modelViewerUI.pause();
    }
  });
}

var productMediaFocusableSelector = [
  'a[href]',
  'button',
  'input',
  'select',
  'textarea',
  'iframe',
  'object',
  'embed',
  'audio[controls]',
  'video[controls]',
  'model-viewer',
  '[contenteditable]',
  '[tabindex]'
].join(',');

function getProductMediaGallery(scope) {
  if (!scope) return null;
  if (scope.matches && scope.matches('[data-product-media-gallery]')) return scope;
  if (scope.closest) {
    var closestGallery = scope.closest('[data-product-media-gallery]');
    if (closestGallery) return closestGallery;
  }
  return scope.querySelector ? scope.querySelector('[data-product-media-gallery]') : null;
}

function getProductMediaInstanceCells(instance, element, selector) {
  var cells = [];
  if (instance && instance.cells) {
    cells = Array.from(instance.cells).map(function(cell) {
      return cell && (cell.element || cell);
    }).filter(Boolean);
  }
  if (cells.length === 0 && element && element.querySelectorAll) {
    cells = Array.from(element.querySelectorAll(selector));
  }
  return cells.filter(function(cell) {
    return cell.matches &&
      cell.matches(selector) &&
      (!element || !element.contains || element.contains(cell));
  });
}

function isProductMediaCellAvailable(cell) {
  if (!cell || cell.hidden) return false;
  if (cell.style && cell.style.display === 'none') return false;
  return true;
}

function isProductMediaThumbSliderVisible(thumb) {
  if (!thumb) return false;
  var container = thumb.closest ? thumb.closest('.yv-product-small-slider-container') : thumb.parentNode;
  if (!container) return true;
  if (container.hidden || (container.style && container.style.display === 'none')) return false;
  if (typeof window.getComputedStyle === 'function') {
    var computedStyle = window.getComputedStyle(container);
    if (computedStyle && computedStyle.display === 'none') return false;
  }
  return true;
}

function getProductMediaPairs(main, thumb, mainInstance, thumbInstance) {
  var mainCells = getProductMediaInstanceCells(
    mainInstance,
    main,
    '[data-product-media-cell]'
  ).filter(isProductMediaCellAvailable);
  var thumbCells = getProductMediaInstanceCells(
    thumbInstance,
    thumb,
    '[data-product-media-tab]'
  ).filter(isProductMediaCellAvailable);
  var thumbByMediaId = new Map();

  thumbCells.forEach(function(tab) {
    var mediaId = tab.getAttribute('data-product-media-id');
    if (mediaId && !thumbByMediaId.has(mediaId)) thumbByMediaId.set(mediaId, tab);
  });

  return mainCells.map(function(panel) {
    var mediaId = panel.getAttribute('data-product-media-id');
    var tab = mediaId ? thumbByMediaId.get(mediaId) : null;
    return tab ? { mediaId: mediaId, panel: panel, tab: tab } : null;
  }).filter(Boolean);
}

function getProductMediaActivePair(pairs, mainInstance) {
  var selectedElements = getProductMediaSelectedElements(mainInstance);

  var selectedPair = pairs.find(function(pair) {
    return selectedElements.indexOf(pair.panel) !== -1;
  });
  if (selectedPair) return selectedPair;

  selectedPair = pairs.find(function(pair) {
    return pair.panel.classList && pair.panel.classList.contains('is-selected');
  });
  return selectedPair || pairs[0] || null;
}

function getProductMediaSelectedElements(instance) {
  if (!instance) return [];
  if (instance.selectedElements) return Array.from(instance.selectedElements);
  if (instance.selectedElement) return [instance.selectedElement];
  if (instance.selectedCells) {
    return Array.from(instance.selectedCells).map(function(cell) {
      return cell && (cell.element || cell);
    }).filter(Boolean);
  }
  if (
    typeof instance.selectedIndex === 'number' &&
    instance.cells &&
    instance.cells[instance.selectedIndex]
  ) {
    return [instance.cells[instance.selectedIndex].element || instance.cells[instance.selectedIndex]];
  }
  return [];
}

function productMediaPairsMatch(firstPairs, secondPairs) {
  if (!firstPairs || firstPairs.length !== secondPairs.length) return false;
  return firstPairs.every(function(pair, index) {
    var comparison = secondPairs[index];
    return comparison && pair.panel === comparison.panel && pair.tab === comparison.tab;
  });
}

function rememberProductMediaAttribute(state, element, name) {
  var elementAttributes = state.attributeRecords.get(element);
  if (!elementAttributes) {
    elementAttributes = new Map();
    state.attributeRecords.set(element, elementAttributes);
  }
  if (!elementAttributes.has(name)) {
    elementAttributes.set(name, {
      present: element.hasAttribute(name),
      value: element.getAttribute(name)
    });
  }
}

function setProductMediaAttribute(state, element, name, value) {
  rememberProductMediaAttribute(state, element, name);
  if (value === null || value === undefined) {
    if (element.hasAttribute(name)) element.removeAttribute(name);
  } else if (element.getAttribute(name) !== String(value)) {
    element.setAttribute(name, value);
  }
}

function restoreProductMediaAttributes(state) {
  state.attributeRecords.forEach(function(attributes, element) {
    attributes.forEach(function(original, name) {
      if (original.present) {
        element.setAttribute(name, original.value);
      } else {
        element.removeAttribute(name);
      }
    });
  });
  state.attributeRecords.clear();
}

function disableProductMediaFocusable(state, element) {
  if (!state.focusRecords.has(element)) {
    state.focusRecords.set(element, {
      present: element.hasAttribute('tabindex'),
      value: element.getAttribute('tabindex')
    });
  }
  if (element.getAttribute('tabindex') !== '-1') element.setAttribute('tabindex', '-1');
}

function restoreProductMediaFocusable(state) {
  state.focusRecords.forEach(function(original, element) {
    if (original.present) {
      element.setAttribute('tabindex', original.value);
    } else {
      element.removeAttribute('tabindex');
    }
  });
  state.focusRecords.clear();
}

function restoreProductMediaFocusableWithin(state, panel) {
  state.focusRecords.forEach(function(original, element) {
    if (!panel.contains || !panel.contains(element)) return;
    if (original.present) {
      element.setAttribute('tabindex', original.value);
    } else {
      element.removeAttribute('tabindex');
    }
    state.focusRecords.delete(element);
  });
}

function focusProductMediaTab(tab) {
  if (!tab || typeof tab.focus !== 'function') return;
  try {
    tab.focus({ preventScroll: true });
  } catch (error) {
    tab.focus();
  }
}

function keepProductMediaFocusInActivePanel(state) {
  if (!state.activePair || !document.activeElement) return;
  var inactiveFocused = state.pairs.some(function(pair) {
    return pair !== state.activePair && pair.panel.contains && pair.panel.contains(document.activeElement);
  });
  if (inactiveFocused) focusProductMediaTab(state.activePair.tab);
}

function applyProductMediaFocusFallback(state) {
  keepProductMediaFocusInActivePanel(state);
  if (state.supportsNativeInert) return;
  state.pairs.forEach(function(pair) {
    if (pair === state.activePair || !pair.panel.querySelectorAll) return;
    Array.from(pair.panel.querySelectorAll(productMediaFocusableSelector)).forEach(function(element) {
      disableProductMediaFocusable(state, element);
    });
  });
}

function getProductMediaOrientation(gallery, pairs) {
  if (
    gallery.classList &&
    (gallery.classList.contains('thumbnail-position-left') ||
      gallery.classList.contains('thumbnail-position-right'))
  ) {
    return 'vertical';
  }
  if (gallery.classList && gallery.classList.contains('thumbnail-position-center')) {
    return 'horizontal';
  }
  if (pairs.length > 1 && pairs[0].tab.getBoundingClientRect && pairs[1].tab.getBoundingClientRect) {
    var firstBounds = pairs[0].tab.getBoundingClientRect();
    var secondBounds = pairs[1].tab.getBoundingClientRect();
    var horizontalDistance = Math.abs((secondBounds.left || 0) - (firstBounds.left || 0));
    var verticalDistance = Math.abs((secondBounds.top || 0) - (firstBounds.top || 0));
    if (horizontalDistance || verticalDistance) {
      return verticalDistance > horizontalDistance ? 'vertical' : 'horizontal';
    }
  }
  return 'horizontal';
}

function formatProductMediaTabLabel(pair, index, count, galleryLabel) {
  var mediaType = (pair.tab.getAttribute('data-product-media-type') || 'media').replace(/_/g, ' ');
  var mediaLabel = pair.tab.getAttribute('data-product-media-label') ||
    pair.panel.getAttribute('data-product-media-label') ||
    galleryLabel ||
    'Product media';
  return mediaType + ': ' + mediaLabel + ', ' + (index + 1) + '/' + count;
}

function getProductMediaStateTab(state, target) {
  if (!target || !target.closest) return null;
  var tab = target.closest('[data-product-media-tab]');
  if (!tab || !state.thumb.contains || !state.thumb.contains(tab)) return null;
  return tab;
}

function selectProductMediaPair(state, pair, moveFocus) {
  if (!pair || !state.mainInstance || typeof state.mainInstance.select !== 'function') return;
  var mainCells = getProductMediaInstanceCells(
    state.mainInstance,
    state.main,
    '[data-product-media-cell]'
  );
  var selectedIndex = mainCells.indexOf(pair.panel);
  if (selectedIndex < 0) return;
  state.mainInstance.select(selectedIndex);
  if (moveFocus) focusProductMediaTab(pair.tab);
}

function handleProductMediaTabClick(state, event) {
  var tab = getProductMediaStateTab(state, event.target);
  if (!tab) return;
  var pair = state.pairs.find(function(candidate) { return candidate.tab === tab; });
  if (!pair) return;
  if (typeof event.preventDefault === 'function') event.preventDefault();
  if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  selectProductMediaPair(state, pair, false);
}

function handleProductMediaTabKeydown(state, event) {
  var tab = getProductMediaStateTab(state, event.target);
  if (!tab) return;
  var currentIndex = state.pairs.findIndex(function(pair) { return pair.tab === tab; });
  if (currentIndex < 0) return;

  var nextIndex = null;
  if (event.key === 'Home') nextIndex = 0;
  if (event.key === 'End') nextIndex = state.pairs.length - 1;
  if (state.orientation === 'horizontal') {
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + state.pairs.length) % state.pairs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % state.pairs.length;
  } else {
    if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + state.pairs.length) % state.pairs.length;
    if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % state.pairs.length;
  }

  var activateCurrent = event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar';
  if (nextIndex === null && !activateCurrent) return;
  if (typeof event.preventDefault === 'function') event.preventDefault();
  selectProductMediaPair(state, state.pairs[nextIndex === null ? currentIndex : nextIndex], true);
}

function createProductMediaGalleryState(gallery, main, thumb, mainInstance, thumbInstance) {
  var state = {
    gallery: gallery,
    main: main,
    thumb: thumb,
    mainInstance: mainInstance,
    thumbInstance: thumbInstance,
    pairs: [],
    activePair: null,
    orientation: 'horizontal',
    attributeRecords: new Map(),
    focusRecords: new Map(),
    supportsNativeInert: false,
    observer: null,
    clickHandler: null,
    keydownHandler: null,
    focusinHandler: null
  };

  state.clickHandler = function(event) { handleProductMediaTabClick(state, event); };
  state.keydownHandler = function(event) { handleProductMediaTabKeydown(state, event); };
  state.focusinHandler = function(event) {
    if (!state.activePair) return;
    var inactivePair = state.pairs.find(function(pair) {
      return pair !== state.activePair && pair.panel.contains && pair.panel.contains(event.target);
    });
    if (inactivePair) focusProductMediaTab(state.activePair.tab);
  };
  thumb.addEventListener('click', state.clickHandler, true);
  thumb.addEventListener('keydown', state.keydownHandler);
  main.addEventListener('focusin', state.focusinHandler);

  var supportsNativeInert = typeof HTMLElement !== 'undefined' &&
    HTMLElement.prototype &&
    'inert' in HTMLElement.prototype;
  state.supportsNativeInert = supportsNativeInert;
  if (!supportsNativeInert && typeof MutationObserver !== 'undefined') {
    state.observer = new MutationObserver(function() {
      scheduleProductGalleryAccessibility(state.gallery, true);
    });
    state.observer.observe(main, { childList: true, subtree: true });
  }
  upvProductLifecycle.productMediaGalleryStates.set(gallery, state);
  return state;
}

function clearProductGalleryAccessibility(scope) {
  var gallery = getProductMediaGallery(scope);
  if (!gallery) return;
  var state = upvProductLifecycle.productMediaGalleryStates.get(gallery);
  if (!state) return;

  restoreProductMediaFocusable(state);
  restoreProductMediaAttributes(state);
  if (getProductFlickity(state.thumb) === state.thumbInstance) {
    var selectedTabs = getProductMediaSelectedElements(state.thumbInstance);
    var currentTabs = getProductMediaInstanceCells(
      state.thumbInstance,
      state.thumb,
      '[data-product-media-tab]'
    );
    if (selectedTabs.length === 0 && state.activePair) selectedTabs = [state.activePair.tab];
    currentTabs.forEach(function(tab) {
      if (selectedTabs.indexOf(tab) !== -1) {
        tab.removeAttribute('aria-hidden');
      } else {
        tab.setAttribute('aria-hidden', 'true');
      }
    });
  }
  state.thumb.removeEventListener('click', state.clickHandler, true);
  state.thumb.removeEventListener('keydown', state.keydownHandler);
  state.main.removeEventListener('focusin', state.focusinHandler);
  if (state.observer) state.observer.disconnect();
  upvProductLifecycle.productMediaSyncTasks.delete(gallery);
  state.pairs = [];
  state.activePair = null;
  upvProductLifecycle.productMediaGalleryStates.delete(gallery);
}

function syncProductGalleryAccessibility(scope, forceRebuild) {
  var gallery = getProductMediaGallery(scope);
  if (!gallery) return null;
  var main = gallery.querySelector('[data-flickity-product-slider]');
  var thumb = gallery.querySelector('[data-flickity-product-thumb-slider]');
  var mainInstance = getProductFlickity(main);
  var thumbInstance = getProductFlickity(thumb);
  if (
    !main ||
    !thumb ||
    !mainInstance ||
    !thumbInstance ||
    !shouldEnableProductSlider(main) ||
    !shouldEnableProductSlider(thumb) ||
    !isProductMediaThumbSliderVisible(thumb)
  ) {
    clearProductGalleryAccessibility(gallery);
    return null;
  }

  var pairs = getProductMediaPairs(main, thumb, mainInstance, thumbInstance);
  if (pairs.length <= 1) {
    clearProductGalleryAccessibility(gallery);
    return null;
  }

  var state = upvProductLifecycle.productMediaGalleryStates.get(gallery);
  var requiresRebuild = Boolean(forceRebuild);
  if (
    !state ||
    state.main !== main ||
    state.thumb !== thumb ||
    state.mainInstance !== mainInstance ||
    state.thumbInstance !== thumbInstance
  ) {
    clearProductGalleryAccessibility(gallery);
    state = createProductMediaGalleryState(gallery, main, thumb, mainInstance, thumbInstance);
    requiresRebuild = true;
  } else if (!productMediaPairsMatch(state.pairs, pairs)) {
    requiresRebuild = true;
  }

  if (requiresRebuild && state.attributeRecords.size > 0) {
    restoreProductMediaFocusable(state);
    restoreProductMediaAttributes(state);
  }

  var previousActivePair = state.activePair;
  state.pairs = pairs;
  state.activePair = getProductMediaActivePair(pairs, mainInstance);
  state.orientation = getProductMediaOrientation(gallery, pairs);
  var galleryLabel = gallery.getAttribute('data-product-media-label') || 'Product media';

  if (requiresRebuild) {
    setProductMediaAttribute(state, gallery, 'role', 'group');
    setProductMediaAttribute(state, gallery, 'aria-roledescription', 'carousel');
    setProductMediaAttribute(state, gallery, 'aria-label', galleryLabel);
    setProductMediaAttribute(state, main, 'aria-live', 'polite');
    setProductMediaAttribute(state, thumb, 'role', 'tablist');
    setProductMediaAttribute(state, thumb, 'aria-label', galleryLabel);
    setProductMediaAttribute(state, thumb, 'aria-orientation', state.orientation);
    setProductMediaAttribute(state, thumb, 'tabindex', null);
  }

  if (!requiresRebuild && previousActivePair !== state.activePair && state.activePair) {
    restoreProductMediaFocusableWithin(state, state.activePair.panel);
  }

  pairs.forEach(function(pair, index) {
    var isActive = pair === state.activePair;
    if (requiresRebuild) {
      setProductMediaAttribute(state, pair.panel, 'role', 'tabpanel');
      if (pair.tab.id) {
        setProductMediaAttribute(state, pair.panel, 'aria-labelledby', pair.tab.id);
        setProductMediaAttribute(state, pair.tab, 'aria-controls', pair.panel.id);
      }
      setProductMediaAttribute(state, pair.tab, 'role', 'tab');
      setProductMediaAttribute(state, pair.tab, 'aria-label', formatProductMediaTabLabel(
        pair,
        index,
        pairs.length,
        galleryLabel
      ));
    }
    setProductMediaAttribute(state, pair.tab, 'aria-selected', isActive ? 'true' : 'false');
    setProductMediaAttribute(state, pair.tab, 'tabindex', isActive ? '0' : '-1');

    // Flickity marks every non-selected thumbnail aria-hidden even when it remains visible.
    // Tabs must all stay exposed so arrow-key navigation can reach them.
    if (pair.tab.hasAttribute('aria-hidden')) pair.tab.removeAttribute('aria-hidden');

    setProductMediaAttribute(state, pair.panel, 'inert', isActive ? null : '');
  });

  applyProductMediaFocusFallback(state);
  return state;
}

function scheduleProductGalleryAccessibility(scope, forceRebuild) {
  var gallery = getProductMediaGallery(scope);
  if (!gallery) return;
  var queuedTask = upvProductLifecycle.productMediaSyncTasks.get(gallery);
  if (queuedTask) {
    if (forceRebuild) queuedTask.forceRebuild = true;
    return;
  }

  var task = { forceRebuild: Boolean(forceRebuild) };
  upvProductLifecycle.productMediaSyncTasks.set(gallery, task);
  var schedule = typeof queueMicrotask === 'function'
    ? queueMicrotask
    : function(callback) { Promise.resolve().then(callback); };
  schedule(function() {
    if (upvProductLifecycle.productMediaSyncTasks.get(gallery) !== task) return;
    upvProductLifecycle.productMediaSyncTasks.delete(gallery);
    syncProductGalleryAccessibility(gallery, task.forceRebuild);
  });
}

function bindProductMediaSliderSelect(element, instance, kind) {
  if (
    !instance ||
    typeof instance.on !== 'function' ||
    upvProductLifecycle.productMediaSelectHandlers.has(instance)
  ) {
    return;
  }
  var selectHandler = function() {
    var gallery = getProductMediaGallery(element);
    if (!gallery) return;
    if (kind === 'thumb') {
      var queuedTask = upvProductLifecycle.productMediaSyncTasks.get(gallery);
      upvProductLifecycle.productMediaSyncTasks.delete(gallery);
      syncProductGalleryAccessibility(gallery, queuedTask && queuedTask.forceRebuild);
      return;
    }
    var state = upvProductLifecycle.productMediaGalleryStates.get(gallery);
    var selectedPair = state && getProductMediaActivePair(state.pairs, instance);
    if (state && selectedPair === state.activePair) return;
    scheduleProductGalleryAccessibility(gallery, false);
  };
  upvProductLifecycle.productMediaSelectHandlers.set(instance, selectHandler);
  instance.on('select', selectHandler);
}

function bindProductSliderChange(element, instance) {
  if (!instance || typeof instance.on !== 'function' || upvProductLifecycle.sliderChangeHandlers.has(instance)) {
    return;
  }
  var changeHandler = function() {
    pauseProductMedia(element);
  };
  upvProductLifecycle.sliderChangeHandlers.set(instance, changeHandler);
  instance.on('change', changeHandler);
}

function scheduleProductSliderResize(element, instance, delay) {
  var previousTimer = upvProductLifecycle.sliderResizeTimers.get(element);
  if (previousTimer) clearTimeout(previousTimer);
  var timer = setTimeout(function() {
    upvProductLifecycle.sliderResizeTimers.delete(element);
    if (getProductFlickity(element) === instance && typeof instance.resize === 'function') {
      instance.resize();
    }
  }, delay);
  upvProductLifecycle.sliderResizeTimers.set(element, timer);
}

function destroyProductSliderElement(element, kind) {
  var instance = getProductFlickity(element);
  if (element) clearProductGalleryAccessibility(element);
  var resizeTimer = element && upvProductLifecycle.sliderResizeTimers.get(element);
  if (resizeTimer) {
    clearTimeout(resizeTimer);
    upvProductLifecycle.sliderResizeTimers.delete(element);
  }
  if (!instance) {
    var legacyInstance = getLegacyProductSlider(kind);
    var legacyElement = legacyInstance && (
      legacyInstance.element ||
      (legacyInstance.$element && legacyInstance.$element[0])
    );
    if (legacyElement === element) setLegacyProductSlider(kind, undefined);
    return null;
  }
  var changeHandler = upvProductLifecycle.sliderChangeHandlers.get(instance);
  if (changeHandler && typeof instance.off === 'function') {
    instance.off('change', changeHandler);
  }
  upvProductLifecycle.sliderChangeHandlers.delete(instance);
  var selectHandler = upvProductLifecycle.productMediaSelectHandlers.get(instance);
  if (selectHandler && typeof instance.off === 'function') {
    instance.off('select', selectHandler);
  }
  upvProductLifecycle.productMediaSelectHandlers.delete(instance);
  if (typeof instance.destroy === 'function') instance.destroy();
  if (getLegacyProductSlider(kind) === instance) {
    setLegacyProductSlider(kind, undefined);
  }
  return instance;
}

function initProductSliderElement(element, attribute, kind) {
  if (!element) return null;
  var optionContainer = element.getAttribute(attribute);
  if (!optionContainer) return null;
  if (!shouldEnableProductSlider(element)) {
    destroyProductSliderElement(element, kind);
    return null;
  }

  var instance = getProductFlickity(element);
  if (!instance) {
    if (typeof Flickity === 'undefined') return null;
    var options;
    try {
      options = JSON.parse(optionContainer);
    } catch (error) {
      console.warn('UPVANITY: invalid product slider options', error);
      return null;
    }
    instance = new Flickity(element, options);
    scheduleProductSliderResize(element, instance, kind === 'thumb' ? 0 : 300);
  }
  setLegacyProductSlider(kind, instance);
  bindProductSliderChange(element, instance);
  bindProductMediaSliderSelect(element, instance, kind);
  syncProductGalleryAccessibility(element);
  return instance;
}

function initProductSlider(section) {
  var sliderMain = getProductElement(section || document, '[data-flickity-product-slider]');
  return initProductSliderElement(sliderMain, 'data-flickity-product-slider', 'main');
}

function initProductThumbSlider(section) {
  var sliderMain = getProductElement(section || document, '[data-flickity-product-thumb-slider]');
  return initProductSliderElement(sliderMain, 'data-flickity-product-thumb-slider', 'thumb');
}

function destroyProductSlider(section) {
  var sliderMain = getProductElement(section || document, '[data-flickity-product-slider]');
  return destroyProductSliderElement(sliderMain, 'main');
}

function destroyProductThumbSlider(section) {
  var sliderMain = getProductElement(section || document, '[data-flickity-product-thumb-slider]');
  return destroyProductSliderElement(sliderMain, 'thumb');
}

function syncProductSlidersForBreakpoint(section) {
  var root = section || document;
  var mainElement = getProductElement(root, '[data-flickity-product-slider]');
  var thumbElement = getProductElement(root, '[data-flickity-product-thumb-slider]');
  var mainEnabled = mainElement && shouldEnableProductSlider(mainElement);
  var thumbEnabled = thumbElement && shouldEnableProductSlider(thumbElement);

  if (thumbElement && !thumbEnabled) destroyProductSliderElement(thumbElement, 'thumb');
  if (mainElement && !mainEnabled) destroyProductSliderElement(mainElement, 'main');
  if (mainEnabled) initProductSliderElement(mainElement, 'data-flickity-product-slider', 'main');
  if (thumbEnabled) initProductSliderElement(thumbElement, 'data-flickity-product-thumb-slider', 'thumb');
}

function getProductModelSlider(model) {
  var section = model.closest && model.closest('.shopify-section');
  var sliderElement = section && section.querySelector('[data-flickity-product-slider]');
  return getProductFlickity(sliderElement);
}

function suspendProductModelSlider(model, record) {
  if (record.sliderState) return;
  var activeSlider = getProductModelSlider(model);
  if (!activeSlider || !activeSlider.options) return;
  record.sliderState = {
    instance: activeSlider,
    draggable: activeSlider.options.draggable
  };
  if (activeSlider.options.draggable !== false) {
    activeSlider.options.draggable = false;
    activeSlider.updateDraggable();
  }
}

function restoreProductModelSlider(model, record) {
  var sliderState = record.sliderState;
  if (!sliderState) return;
  record.sliderState = null;
  var activeSlider = getProductModelSlider(model);
  if (activeSlider !== sliderState.instance || !activeSlider.options) return;
  if (activeSlider.options.draggable !== sliderState.draggable) {
    activeSlider.options.draggable = sliderState.draggable;
    activeSlider.updateDraggable();
  }
}

function focusProductModelPoster(model, modelViewerUI) {
  var controlButton = modelViewerUI && modelViewerUI.elements && modelViewerUI.elements.controlButton;
  if (!controlButton && model.querySelector) {
    controlButton = model.querySelector('.shopify-model-viewer-ui__button--poster');
  }
  if (!controlButton || typeof controlButton.focus !== 'function' || controlButton.disabled) return false;
  try {
    controlButton.focus({ preventScroll: true });
  } catch (error) {
    controlButton.focus();
  }
  return document.activeElement === controlButton;
}

function initProductModelViewerItem(model) {
  if (
    !model ||
    upvProductLifecycle.productModelRecords.has(model) ||
    !window.Shopify ||
    typeof window.Shopify.ModelViewerUI !== 'function'
  ) {
    return;
  }

  var model3D = model.querySelector('model-viewer');
  if (!model3D) return;

  var modelViewerUI;
  try {
    modelViewerUI = new window.Shopify.ModelViewerUI(model3D);
  } catch (error) {
    console.warn('UPVANITY: unable to initialize product Model Viewer', error);
    return;
  }

  var record = {
    model3D: model3D,
    modelViewerUI: modelViewerUI,
    playHandler: null,
    pauseHandler: null,
    closeHandlers: [],
    sliderState: null
  };
  var playHandler = function() {
    model.querySelectorAll('.close-product-model').forEach(function(element) {
      element.classList.remove('hidden');
    });
    suspendProductModelSlider(model, record);
  };
  var pauseHandler = function() {
    model.querySelectorAll('.close-product-model').forEach(function(element) {
      element.classList.add('hidden');
    });
    restoreProductModelSlider(model, record);
  };
  var closeHandlers = [];

  model3D.addEventListener('shopify_model_viewer_ui_toggle_play', playHandler);
  model3D.addEventListener('shopify_model_viewer_ui_toggle_pause', pauseHandler);
  model.querySelectorAll('.close-product-model').forEach(function(element) {
    var closeHandler = function() {
      var shouldRestoreFocus = document.activeElement === element;
      modelViewerUI.pause();
      if (shouldRestoreFocus) focusProductModelPoster(model, modelViewerUI);
    };
    closeHandlers.push({ element: element, handler: closeHandler });
    element.addEventListener('click', closeHandler);
  });

  model.modelViewerUI = modelViewerUI;
  record.playHandler = playHandler;
  record.pauseHandler = pauseHandler;
  record.closeHandlers = closeHandlers;
  upvProductLifecycle.productModelRecords.set(model, record);
}

function runProductModelCleanup(callback, warning) {
  try {
    callback();
  } catch (error) {
    try {
      if (typeof console !== 'undefined' && typeof console.warn === 'function') {
        console.warn('UPVANITY: ' + warning, error);
      }
    } catch (warningError) {
      // A patched logger must never interrupt teardown.
    }
  }
}

function destroyProductModelViewerItem(model) {
  var record = upvProductLifecycle.productModelRecords.get(model);
  if (!record) return;

  runProductModelCleanup(function() {
    record.model3D.removeEventListener('shopify_model_viewer_ui_toggle_play', record.playHandler);
    record.model3D.removeEventListener('shopify_model_viewer_ui_toggle_pause', record.pauseHandler);
  }, 'unable to remove product Model Viewer listeners');
  record.closeHandlers.forEach(function(closeRecord) {
    runProductModelCleanup(function() {
      closeRecord.element.removeEventListener('click', closeRecord.handler);
    }, 'unable to remove a product Model Viewer close listener');
    runProductModelCleanup(function() {
      closeRecord.element.classList.add('hidden');
    }, 'unable to reset a product Model Viewer close control');
  });
  runProductModelCleanup(function() {
    restoreProductModelSlider(model, record);
  }, 'unable to restore the product slider after Model Viewer teardown');

  if (record.modelViewerUI && typeof record.modelViewerUI.pause === 'function') {
    runProductModelCleanup(function() {
      record.modelViewerUI.pause();
    }, 'unable to pause the product Model Viewer during teardown');
  }
  if (record.modelViewerUI && typeof record.modelViewerUI.destroy === 'function') {
    runProductModelCleanup(function() {
      record.modelViewerUI.destroy();
    }, 'unable to destroy the product Model Viewer');
  }
  runProductModelCleanup(function() {
    if (model.modelViewerUI === record.modelViewerUI) delete model.modelViewerUI;
  }, 'unable to clear the product Model Viewer reference');
  upvProductLifecycle.productModelRecords.delete(model);
}

var productMediaModel = {
  setupModelViewerUI: function(errors, section) {
    if (errors) {
      upvProductLifecycle.productModelFeaturesRequested = false;
      return;
    }
    if (!window.Shopify || typeof window.Shopify.ModelViewerUI !== 'function') return;
    getProductElements(section || document, '.yv-product-model-item').forEach(initProductModelViewerItem);
  },

  setupShopifyXR: function(errors, section) {
    if (errors) {
      upvProductLifecycle.productModelFeaturesRequested = false;
      return;
    }
    if (!window.ShopifyXR) {
      if (!upvProductLifecycle.shopifyXRReadyHandler) {
        upvProductLifecycle.shopifyXRReadyHandler = function() {
          document.removeEventListener('shopify_xr_initialized', upvProductLifecycle.shopifyXRReadyHandler);
          upvProductLifecycle.shopifyXRReadyHandler = null;
          productMediaModel.setupShopifyXR(null, document);
        };
        document.addEventListener('shopify_xr_initialized', upvProductLifecycle.shopifyXRReadyHandler);
      }
      return;
    }

    if (upvProductLifecycle.shopifyXRReadyHandler) {
      document.removeEventListener('shopify_xr_initialized', upvProductLifecycle.shopifyXRReadyHandler);
      upvProductLifecycle.shopifyXRReadyHandler = null;
    }

    var shouldSetupXRElements = false;
    getProductElements(section || document, '[id^="product3DModel-"]').forEach(function(modelJson) {
      if (upvProductLifecycle.processedProductModelJson.has(modelJson)) return;
      var models;
      try {
        models = JSON.parse(modelJson.textContent);
      } catch (error) {
        upvProductLifecycle.processedProductModelJson.add(modelJson);
        console.warn('UPVANITY: invalid product model JSON', error);
        return;
      }
      if (!Array.isArray(models) || models.length === 0) {
        upvProductLifecycle.processedProductModelJson.add(modelJson);
        return;
      }
      try {
        window.ShopifyXR.addModels(models);
        upvProductLifecycle.processedProductModelJson.add(modelJson);
        shouldSetupXRElements = true;
      } catch (error) {
        console.warn('UPVANITY: unable to register product models with Shopify XR', error);
      }
    });
    if (shouldSetupXRElements && typeof window.ShopifyXR.setupXRElements === 'function') {
      window.ShopifyXR.setupXRElements();
    }
  },

  loadShopifyXR: function(section) {
    var root = section || document;
    if (getProductElements(root, '[id^="product3DModel-"]').length === 0) return;

    this.setupShopifyXR(null, root);
    this.setupModelViewerUI(null, root);
    if (upvProductLifecycle.productModelFeaturesRequested) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    upvProductLifecycle.productModelFeaturesRequested = true;
    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: function(errors) {
          productMediaModel.setupShopifyXR(errors, document);
        }
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: function(errors) {
          productMediaModel.setupModelViewerUI(errors, document);
        }
      }
    ]);
  }
};

function initProductModels(section) {
  productMediaModel.loadShopifyXR(section || document);
}

function destroyProductModels(section) {
  getProductElements(section || document, '.yv-product-model-item').forEach(destroyProductModelViewerItem);
}

function getProductElements(section, selector) {
  var root = section || document;
  var elements = root.querySelectorAll ? Array.from(root.querySelectorAll(selector)) : [];
  if (root.matches && root.matches(selector)) elements.unshift(root);
  return elements;
}

function updateGalleryActiveThumb() {
  var mainSliderParent = document.getElementById('yv-product-gallery-slider');
  if (!mainSliderParent || typeof isOnScreen !== 'function') return;
  var elements = mainSliderParent.getElementsByClassName('gallery-main-item');
  var visibleItem = null;
  Array.from(elements).forEach(function(item) {
    if (isOnScreen(item)) visibleItem = item;
  });
  if (!visibleItem) return;
  var relatedThumb = mainSliderParent.querySelector('.gallery-thumbs-item[data-image="' + visibleItem.id + '"]');
  if (!relatedThumb) return;
  Array.from(mainSliderParent.getElementsByClassName('gallery-thumbs-item')).forEach(function(thumb) {
    thumb.classList.toggle('active', thumb === relatedThumb);
  });
}

function updateProductFeatureTab() {
  var featureList = document.getElementById('yvProductFeatureListwrapper');
  if (!featureList || typeof isOnScreen !== 'function') return;
  var featureContainer = featureList.parentElement;
  if (
    featureContainer &&
    featureContainer.classList.contains('yv-product-features') &&
    window.getComputedStyle(featureContainer).display === 'none'
  ) return;
  var visibleFeature = null;
  Array.from(document.getElementsByClassName('yv-product-feature')).forEach(function(item) {
    if (isOnScreen(item)) visibleFeature = item;
  });
  if (!visibleFeature) return;
  var relatedHead = document.querySelector('.feature-link[href="#' + visibleFeature.id + '"]');
  if (!relatedHead) return;
  Array.from(document.getElementsByClassName('feature-link')).forEach(function(head) {
    if (head.parentNode) head.parentNode.classList.toggle('active', head === relatedHead);
  });
}

function updateStickyAddToCart() {
  if (typeof cartAdd === 'undefined' || typeof isOnScreen !== 'function') return;
  var mainProductForm = document.querySelector('.main-product-form[action^="' + cartAdd + '"]');
  var stickyBar = document.getElementById('yvProductStickyBar');
  if (!mainProductForm || !stickyBar) return;
  if (isOnScreen(mainProductForm, true) || window.scrollY < mainProductForm.offsetTop) {
    stickyBar.classList.remove('show');
  } else {
    stickyBar.classList.add('show');
  }
}

function updateStickyProductThumbnails() {
  var thumbnails = document.querySelector('.yv-product-gallery-thumbs-container');
  if (!thumbnails) {
    upvProductLifecycle.thumbnailState = null;
    return;
  }
  var state = upvProductLifecycle.thumbnailState;
  if (!state || state.element !== thumbnails) {
    var initialTopOffset = parseInt(window.getComputedStyle(thumbnails).top, 10);
    state = {
      element: thumbnails,
      lastKnownY: window.scrollY,
      currentTop: 0,
      initialTopOffset: Number.isFinite(initialTopOffset) ? initialTopOffset : 0
    };
    upvProductLifecycle.thumbnailState = state;
  }
  var bounds = thumbnails.getBoundingClientRect();
  var maxTop = bounds.top + window.scrollY - thumbnails.offsetTop + state.initialTopOffset;
  var minTop = thumbnails.clientHeight - window.innerHeight;
  if (window.scrollY < state.lastKnownY) {
    state.currentTop -= window.scrollY - state.lastKnownY;
  } else {
    state.currentTop += state.lastKnownY - window.scrollY;
  }
  state.currentTop = Math.min(
    Math.max(state.currentTop, -minTop),
    maxTop,
    state.initialTopOffset
  );
  state.lastKnownY = window.scrollY;
  thumbnails.style.top = String(state.currentTop) + 'px';
}

function runProductScrollUpdate() {
  upvProductLifecycle.scrollFrame = null;
  updateGalleryActiveThumb();
  updateProductFeatureTab();
  updateStickyAddToCart();
  updateStickyProductThumbnails();
}

function requestProductScrollUpdate() {
  if (upvProductLifecycle.scrollFrame !== null) return;
  var requestFrame = window.requestAnimationFrame || function(callback) {
    return setTimeout(callback, 16);
  };
  upvProductLifecycle.scrollFrame = requestFrame(runProductScrollUpdate);
}

function findVisibleItems() {
  requestProductScrollUpdate();
}

function initStickyAddToCart() {
  requestProductScrollUpdate();
}

function showSizeChart(model) {
  model.style.display = 'inline-block';
  model.style.visibility = 'visible';
  model.style.opacity = '1';
  model.style.filter = 'alpha(opacity=100)';
}

function hideSizeChart(model) {
  model.style.display = 'none';
  model.style.visibility = 'hidden';
  model.style.opacity = '0';
  model.style.filter = 'alpha(opacity=0)';
}

function bindSizeChartTrigger(trigger) {
  if (upvProductLifecycle.sizeChartHandlers.has(trigger)) return;
  var handler = function(event) {
    event.preventDefault();
    var section = trigger.closest ? trigger.closest('.shopify-section') : null;
    var model = (section && section.querySelector('#sizeChartModel')) || document.getElementById('sizeChartModel');
    if (!model) return;
    showSizeChart(model);
    document.body.classList.add('sizeChartOpen');
    focusElement = trigger;
    var close = model.querySelector('#sizeChartClose');
    if (close && typeof close.focus === 'function') close.focus();
  };
  upvProductLifecycle.sizeChartHandlers.set(trigger, handler);
  trigger.addEventListener('click', handler);
}

function bindSizeChartClose(close) {
  if (upvProductLifecycle.sizeChartHandlers.has(close)) return;
  var handler = function() {
    var model = close.closest ? close.closest('.sizeChart-wrapper') : null;
    if (!model) model = document.getElementById('sizeChartModel');
    document.body.classList.remove('sizeChartOpen');
    if (model) hideSizeChart(model);
    if (focusElement && focusElement.isConnected !== false && typeof focusElement.focus === 'function') {
      focusElement.focus();
    }
    focusElement = '';
  };
  upvProductLifecycle.sizeChartHandlers.set(close, handler);
  close.addEventListener('click', handler);
}

function sizeChart(section) {
  getProductElements(section || document, '.sizeChart-label').forEach(bindSizeChartTrigger);
  getProductElements(section || document, '#sizeChartClose').forEach(bindSizeChartClose);
}

function getMousePos(event) {
  var pos = event.currentTarget.getBoundingClientRect();
  return {
    x: event.clientX - pos.left,
    y: event.clientY - pos.top
  };
}

function productZoomEnabled() {
  return upvProductLifecycle.zoomQuery
    ? upvProductLifecycle.zoomQuery.matches
    : window.innerWidth > 1021;
}

function bindProductZoom(zoom) {
  if (upvProductLifecycle.zoomHandlers.has(zoom)) return;
  var handlers = {
    enter: function() {
      document.querySelectorAll('.yv-product-zoom.show').forEach(function(element) {
        element.classList.remove('show');
      });
      if (productZoomEnabled()) zoom.classList.add('show');
    },
    move: function(event) {
      if (!productZoomEnabled()) return;
      var cursor = zoom.querySelector('.gallery-cursor');
      if (!cursor) return;
      var position = getMousePos(event);
      cursor.style.translate = position.x + 'px ' + position.y + 'px';
    },
    leave: function() {
      zoom.classList.remove('show');
    }
  };
  upvProductLifecycle.zoomHandlers.set(zoom, handlers);
  zoom.addEventListener('mouseenter', handlers.enter);
  zoom.addEventListener('mousemove', handlers.move);
  zoom.addEventListener('mouseleave', handlers.leave);
}

function productZoomInit(section) {
  getProductElements(section || document, '.yv-product-zoom').forEach(bindProductZoom);
}

function cleanupProductBindings(section) {
  getProductElements(section, '.yv-product-zoom').forEach(function(zoom) {
    var handlers = upvProductLifecycle.zoomHandlers.get(zoom);
    if (!handlers) return;
    zoom.removeEventListener('mouseenter', handlers.enter);
    zoom.removeEventListener('mousemove', handlers.move);
    zoom.removeEventListener('mouseleave', handlers.leave);
    zoom.classList.remove('show');
    upvProductLifecycle.zoomHandlers.delete(zoom);
  });
  getProductElements(section, '.sizeChart-label, #sizeChartClose').forEach(function(element) {
    var handler = upvProductLifecycle.sizeChartHandlers.get(element);
    if (handler) element.removeEventListener('click', handler);
    upvProductLifecycle.sizeChartHandlers.delete(element);
  });
  if (
    upvProductLifecycle.thumbnailState &&
    section.contains &&
    section.contains(upvProductLifecycle.thumbnailState.element)
  ) {
    upvProductLifecycle.thumbnailState = null;
  }
}

function initProductSection(section) {
  var root = section || document;
  initProductSlider(root);
  initProductThumbSlider(root);
  initProductModels(root);
  productZoomInit(root);
  sizeChart(root);
  findVisibleItems();
  initStickyAddToCart();
}

function destroyProductSection(section) {
  destroyProductModels(section);
  destroyProductThumbSlider(section);
  destroyProductSlider(section);
  cleanupProductBindings(section);
  requestProductScrollUpdate();
}

function installProductLifecycleListeners() {
  if (upvProductLifecycle.scrollHandler) {
    window.removeEventListener('scroll', upvProductLifecycle.scrollHandler);
  }
  upvProductLifecycle.scrollHandler = requestProductScrollUpdate;
  window.addEventListener('scroll', upvProductLifecycle.scrollHandler, { passive: true });

  if (upvProductLifecycle.breakpointQuery && upvProductLifecycle.breakpointHandler) {
    if (typeof upvProductLifecycle.breakpointQuery.removeEventListener === 'function') {
      upvProductLifecycle.breakpointQuery.removeEventListener('change', upvProductLifecycle.breakpointHandler);
    } else if (typeof upvProductLifecycle.breakpointQuery.removeListener === 'function') {
      upvProductLifecycle.breakpointQuery.removeListener(upvProductLifecycle.breakpointHandler);
    }
  }
  if (window.matchMedia) {
    upvProductLifecycle.breakpointQuery = window.matchMedia('(max-width: 767px)');
    upvProductLifecycle.breakpointHandler = function() {
      syncProductSlidersForBreakpoint(document);
      requestProductScrollUpdate();
    };
    if (typeof upvProductLifecycle.breakpointQuery.addEventListener === 'function') {
      upvProductLifecycle.breakpointQuery.addEventListener('change', upvProductLifecycle.breakpointHandler);
    } else if (typeof upvProductLifecycle.breakpointQuery.addListener === 'function') {
      upvProductLifecycle.breakpointQuery.addListener(upvProductLifecycle.breakpointHandler);
    }

    if (upvProductLifecycle.zoomQuery && upvProductLifecycle.zoomBreakpointHandler) {
      if (typeof upvProductLifecycle.zoomQuery.removeEventListener === 'function') {
        upvProductLifecycle.zoomQuery.removeEventListener('change', upvProductLifecycle.zoomBreakpointHandler);
      } else if (typeof upvProductLifecycle.zoomQuery.removeListener === 'function') {
        upvProductLifecycle.zoomQuery.removeListener(upvProductLifecycle.zoomBreakpointHandler);
      }
    }
    upvProductLifecycle.zoomQuery = window.matchMedia('(min-width: 1022px)');
    upvProductLifecycle.zoomBreakpointHandler = function(event) {
      if (!event.matches) {
        document.querySelectorAll('.yv-product-zoom.show').forEach(function(element) {
          element.classList.remove('show');
        });
      }
    };
    if (typeof upvProductLifecycle.zoomQuery.addEventListener === 'function') {
      upvProductLifecycle.zoomQuery.addEventListener('change', upvProductLifecycle.zoomBreakpointHandler);
    } else if (typeof upvProductLifecycle.zoomQuery.addListener === 'function') {
      upvProductLifecycle.zoomQuery.addListener(upvProductLifecycle.zoomBreakpointHandler);
    }
  }

  if (upvProductLifecycle.sectionLoadHandler) {
    document.removeEventListener('shopify:section:load', upvProductLifecycle.sectionLoadHandler);
  }
  if (upvProductLifecycle.sectionUnloadHandler) {
    document.removeEventListener('shopify:section:unload', upvProductLifecycle.sectionUnloadHandler);
  }
  upvProductLifecycle.sectionLoadHandler = function(event) {
    initProductSection(event.target);
  };
  upvProductLifecycle.sectionUnloadHandler = function(event) {
    destroyProductSection(event.target);
  };
  document.addEventListener('shopify:section:load', upvProductLifecycle.sectionLoadHandler);
  document.addEventListener('shopify:section:unload', upvProductLifecycle.sectionUnloadHandler);

  if (upvProductLifecycle.readyHandler) {
    document.removeEventListener('DOMContentLoaded', upvProductLifecycle.readyHandler);
  }
  upvProductLifecycle.readyHandler = function() {
    initProductSection(document);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', upvProductLifecycle.readyHandler, { once: true });
  } else {
    upvProductLifecycle.readyHandler();
  }
}

installProductLifecycleListeners();



$(document).ready(function(){
  jQuery('body')
    .off('click.upvProductGallery', '.gallery-thumbs-item')
    .on('click.upvProductGallery', '.gallery-thumbs-item', function(e) {
    e.preventDefault();
    var destination = jQuery(this).attr('data-image');
    var top = 10; 
  //  if(jQuery('#headerSection').hasClass('sticky-header')){
      top = jQuery('.shopify-section-main-header').height() + 10;
  //  }
    if(jQuery('#'+destination+'.gallery-main-item').length > 0){
      jQuery('html,body').animate({ scrollTop:(jQuery('#'+destination+'.gallery-main-item').offset().top) - top});
    }
  });


  jQuery('body')
    .off('click.upvProductStickyClose', '.pdp-view-close')
    .on('click.upvProductStickyClose', '.pdp-view-close', function(e) {
    e.preventDefault();
    jQuery('#yvProductStickyBar').remove();    
  });
  jQuery('body')
    .off('click.upvProductFeature', '.feature-link')
    .on('click.upvProductFeature', '.feature-link', function(e) {
    e.preventDefault();

    let destination = jQuery(this).attr('href');
    let top = 10;
    // if(jQuery('#headerSection').hasClass('sticky-header')){
      top = jQuery('.shopify-section-main-header').height() + 90;
    // }
    if(jQuery(destination).length > 0){
      jQuery('html,body').animate({ scrollTop:(jQuery(destination).offset().top) - top});
    }
  });


  jQuery('body')
    .off('change.upvProductStickyOption', '.sticky-bar-product-options')
    .on('change.upvProductStickyOption', '.sticky-bar-product-options', function(){
    let _section = jQuery(this).closest('.shopify-section');
    let option = jQuery(this).attr('data-name');
    let value = jQuery(this).val();
    let mainOption = _section.find('.productOption[name="'+option+'"]');
    if(mainOption.is(':radio')){
      _section.find('.productOption[name="'+option+'"][value="'+value+'"]').attr('checked',true).trigger('click');
    }
    else{
      mainOption.val(value);
      let sectionId = document.querySelector('#'+_section.attr('id'))
      if(sectionId){
        let optionSelector = document.querySelector('.productOption[name="'+option+'"]');
        if(optionSelector){
          optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }    
  })
  if(fancySelector){
    Fancybox.bind(fancySelector, {
      touch: false,
      thumbs : {
        autoStart : true
      },
      on: {
        load: (fancybox, slide) => {
          document.querySelectorAll('.yv-youtube-video').forEach((video) => {
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
          });
          document.querySelectorAll('.yv-youtube-video').forEach((video) => {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
          });
          document.querySelectorAll('video').forEach((video) => video.pause());
          var fancyBoxContainer = $('body').find('.fancybox__container');
        },
        done: (fancybox, slide) => {
          var fancyBoxContainer = $('body').find('.fancybox__container');
        }
      },
      Toolbar: {
        display: [
          "close",
        ],
      }
    });
  }

  function playVideo() {
    currentVideo = $('[data-reel-content] video')[0];
    if (currentVideo) {
      currentVideo.load();
      currentVideo.play();
    }
  }

  function pauseVideo() {
    if (currentVideo) {
      currentVideo.pause();
    }
  }
})
